import { Link } from "react-router-dom";
import { Container, PageTitle, NbCard } from "@/components/nb";
import { Stagger, Item } from "@/components/motion";
import { Compass, Route, Users, ArrowRight } from "lucide-react";

const items = [
  { to: "/career/assess", title: "Interest Assessment", desc: "8 quick questions to reveal your top 3 paths.", icon: Compass, color: "secondary", tid: "career-assess" },
  { to: "/career/path/tech", title: "Explore Paths", desc: "Tech, design, science, business, arts, impact.", icon: Route, color: "tertiary", tid: "career-paths" },
  { to: "/career/mentors", title: "Mentor Connect", desc: "Talk to real people who've done it.", icon: Users, color: "accent", tid: "career-mentors" },
];

export default function CareerHub() {
  return (
    <Container>
      <PageTitle eyebrow="CAREER GUIDANCE" title="Not sure what to be? Same." sub="Start with what you love, map the path, meet the people." />
      <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((i) => {
          const Icon = i.icon;
          return (
            <Item key={i.to}>
              <Link to={i.to} data-testid={i.tid} className="block h-full">
                <NbCard color={i.color} className="h-full min-h-[220px] flex flex-col justify-between nb-hover-lg">
                  <div className="flex justify-between"><Icon className="w-8 h-8" /><ArrowRight className="w-6 h-6" /></div>
                  <div>
                    <h3 className="font-heading font-black text-2xl tracking-tighter">{i.title}</h3>
                    <p className="mt-2 text-neutral-800">{i.desc}</p>
                  </div>
                </NbCard>
              </Link>
            </Item>
          );
        })}
      </Stagger>
    </Container>
  );
}
